export const headTableCell = [
	{ id: 1, property: '', label: '' },
	{ id: 2, property: 'firstName', label: 'First name' },
	{ id: 3, property: 'lastName', label: 'Last name' },
	{ id: 4, property: 'phoneWork', label: 'Work phone' },
	{ id: 5, property: 'phoneMobile', label: 'Mobile phone' },
	{ id: 6, property: 'emailWork', label: 'Email' },
];

export const tableHeadCells = [
	{ id: 1, label: 'First name' },
	{ id: 2, label: 'Last name' },
	{ id: 3, label: 'Work phone' },
	{ id: 4, label: 'Mobile phone' },
	{ id: 5, label: 'Email' },
];
